import React, { Component } from "react";
import { Container, Row, Col, Card, CardImg } from "reactstrap";
import "./style.css";
// modified

class Testimonials extends Component {
  render() {
    return (
      <div className="section-padding dark-background text-center text-md-left">
        <Container>
          <Row>
            <Col sm={{ size: 12 }}>
              <h1 className="all-headers mt-5 mb-3 text-center">
                We Are Building ATL's Top Tech Talent
              </h1>{" "}
              <hr className="heading-underline mb-5" />
            </Col>
          </Row>
          <Row style={{ marginTop: "2rem" }}>
            <Col sm={{ size: 2 }}>
              <Card className="student-pics">
                <CardImg
                  top
                  height="100%"
                  src="img/instructors-steven-v2.png"
                  alt="Card image cap"
                />
              </Card>
            </Col>
            <Col sm={{ size: 4 }} className="pt-3 pt-sm-0">
              {/* <h3 className='yellow-underline'>
                Steven
              </h3>
              <hr className="card-line mb-0 d-none d-md-block" style={{ marginTop: '-.5rem' }} /> */}
              <div className='position-relative d-inline-block'>
                <h3 className='yellow-underline'>
                  Steven
                </h3>
              </div>
              <h3>Full Stack Web Developer</h3>
              <p>
                “Lighthouse focused on adding new skills while strengthing my current skills. This along with the Mentors For Success Program has provided the confidence needed to land my dream job.”
              </p>
            </Col>
            <Col sm={{ size: 2 }}>
              <Card className="student-pics">
                <CardImg
                  top
                  height="100%"
                  src="img/testimonial-shain-v2.png"
                  alt="Card image cap"
                />
              </Card>
            </Col>
            <Col sm={{ size: 4 }} className="pt-3 pt-sm-0">
              <div className='position-relative d-inline-block'>
                <h3 className='yellow-underline'>
                  Shain
                </h3>
              </div>
              
            
              <h3>Full Stack Web Developer</h3>
              <p>
                “I’ve never felt more prepared to work in the industry and also know that Lighthouse will continue to be there for my journey!”
              </p>
            </Col>
          </Row>
          <Row style={{ marginTop: "2rem" }}>
            <Col sm={{ size: 2 }}>
              <Card className="student-pics">
                <CardImg
                  top
                  height="100%"
                  src="img/instructors-inaara-v2.png"
                  alt="Card image cap"
                />
              </Card>
            </Col>
            <Col sm={{ size: 4 }} className="pt-3 pt-sm-0">
            
              <div className='position-relative d-inline-block'>
                <h3 className='yellow-underline'>
                  Inaara
                </h3>
              </div>
              <h3>Digital Marketer</h3>
              <p>
                “The learning studio is so well connected to Atlanta’s growing job and tech culture. I enjoy being a part of the community of talented individuals and companies on a weekly basis.”
              </p>
            </Col>
            <Col sm={{ size: 2 }}>
              <Card className="student-pics">
                <CardImg
                  top
                  height="100%"
                  src="img/instructors-mary-v2.png"
                  alt="Card image cap"
                />
              </Card>
            </Col>
            <Col sm={{ size: 4 }} className="pt-3 pt-sm-0">
             
              <div className='position-relative d-inline-block'>
                <h3 className='yellow-underline'>
                  Mary
                </h3>
              </div>
              <h3>UX & Graphic Designer</h3>
              <p>
                “My favorite aspect of Lighthouse is how the program is invested on your career long-term by helping to continue learning the next set of skills.”
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Testimonials;
